const ErrorMessage = ({ message }) => (
  <div className="flex items-center gap-2 px-3 py-2 bg-[#FEF2F2] rounded-lg border border-red-200 mt-6 text-xl">
    <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <title>Error icon</title>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <span className="text-red-700 text-xl geomanistMedium">{message}</span>
  </div>
);

export default ErrorMessage;